import React, { useEffect, useRef, useState } from "react";
import axios from "../../services/axios";
import Dashboard from "../../layouts/Dashboard";
import { useParams } from "react-router-dom";
import { ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import url from "../../services/url";
import ReactLoading from "react-loading";
import LoadingArea from "../../components/LoadingArea";
import { CheckOutlined, CloseOutlined, EyeOutlined } from "@ant-design/icons";
import { Table, Alert, Badge } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import { Button, Drawer, Collapse, Card, message, Image } from "antd";
import CandidateDocView from "../CandidateDashboard/CandidateDocView";
import swal from "sweetalert";
import BASE from "../../config";
import {
  formatDateDDMMYYYY,
  days,
  months,
  getMonthIndex,
  capitalizeEachWord,
} from "../../utils/commonFunctions";
import "../Documents/forms/Html/formsStyle.css";
import ResponseView from "../CandidateDashboard/Home/ResponseView";
import ConsentForm from "./forms/ConsentForm";
import useGetFile from "../../hooks/useGetFile";
import { Modal, Input, Tag } from "antd";
import {
  SearchOutlined,
  CheckCircleOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import {
  ReadyForReview,
  Pending,
  Rejected,
  Verified,
  Accepted,
} from "../../components/components/StatusIndicators";
import EmployeExperienceSection from "../../components/components/EmployeExperienceSection";
import useLegalPrifilledData from "../../hooks/useLegalPrifilledData";
import useAuthUserToken from "../../hooks/useAuthUserToken";
import { videoExt, docExt, imgExt } from "../../utils/fileExtentions";
import { LOGOS } from "../../utils/companyLogosObj";
import useAxios from "../../hooks/useAxios";
import { formatDDMMYYYY } from "./forms/Html/LeagleDocuments/forms/commonfunctions";
import RejectModal from "../Candidate/components/RejectModal";
import useUserRole from "../../hooks/useUserRole";
import moment from "moment";
import printJS from "print-js";
import Header from "../../components/components/Header";
import { useLocation } from "react-router-dom";
import { DOCUMENT_RIGHTS } from "../../umConfig";
import { ESI_LOGO, ACCIDENTAL, MEDICLAIM, FORM_11 } from "./forms/logos/index";
import BankValidationPopup from "./Components/BankValidationPopup";
import AadharCardSection from "./ui/AadharCardSection";
import PanCardSection from "./ui/PanCardSection";
import PhotoSection from "./ui/PhotoSection";
import SignatureSection from "./ui/SignatureSection";
import UANSection from "./ui/UANSection";
import EditedTag from "./Components/EditedTag";
import OfferLetter from "../CandidateDashboard/ui/OfferLetter";
import AIRemarks from "./Components/AIRemarks";
import { checkBulkPermissions } from "../../utils/checkPermission";

const showAIRemarks = [
  "CancelCheque",
  "BloodGroup",
  "10th",
  "12th",
  "Graduate",
  "Post Graduate",
  "OfferLetter",
  "ExpLetter",
  "SalarySlip",
];

const normalizeFormName = (value = "") =>
  String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

const getCompanyDocument = (form = {}) => form?.companyDocumentId || form;

const isDeclarationDocument = (form = {}) => {
  const document = getCompanyDocument(form);
  const type = document?.formType || form?.formType || "";
  const status = document?.status ?? form?.status ?? true;

  return normalizeFormName(type) === "consent" && status === true;
};

const DocsVerify = () => {
  const email = localStorage.getItem("user.email");
  const api = useAxios();
  const locationUrl = useLocation();
  const searchParams = new URLSearchParams(locationUrl.search);
  const FILTER = searchParams.get("filter" || "") || "";
  const VALUE = searchParams.get("value" || "") || "";
  const { id } = useParams();
  const domParser = new DOMParser();
  const { Panel } = Collapse;
  const [formList, setFormList] = useState([]);
  const [docs, setDocs] = useState([]);
  const [headerModal, setHeaderModal] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [bankErrorMessage, setBankErrorMessage] = useState("");
  const [aadharDetails, setAadharDetails] = useState();
  const [bankDetails, setBankDetails] = useState();
  const [panDetails, setPanDetails] = useState();
  const [toggleAlert, setToggleAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState();
  const [metaData, setMetaData] = useState();
  const [acceptedFormByCan, setAcceptedFormByCan] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [joiningForms, setJoiningForms] = useState([]);
  const [legaljoiningForms, setLegalJoiningForms] = useState([]);
  const [legalFilledForms, setLegalFilledForms] = useState([]);
  const [checklistFilledForms, setChecklistFilledForms] = useState([]);
  const [filledForms, setFilledForms] = useState([]);
  const [joiningTableData, setJoiningTableData] = useState([]);
  const [checklistTableData, setChecklistTableData] = useState([]);
  const [declarationTableData, setDeclarationTableData] = useState([]);
  const [legalTableData, setLegalTableData] = useState([]);
  const [consentTableData, setConsentTableData] = useState([]);
  const [offerLetters, setOfferLetters] = useState([]);
  const [uanDetails, setUanDetails] = useState({});
  const [offerLetterSended, setOfferLetterSended] = useState(null);
  const [modal, setModal] = useState(false);
  const [bankModal, setBankModal] = useState(false);
  const [documentModal, setDocumentModal] = useState(false);
  const [downloadLink, setDownloadLink] = useState("");
  const [docRejectReason, setDocRejectReason] = useState("");
  const [docRejectModal, setDocRejectModal] = useState(false);
  const [formId, setFormId] = useState("");
  const [s3Preview, setS3Preview] = useState(null);
  const { userToken } = useAuthUserToken();
  const { imageLoad, getImage } = useGetFile(userToken);
  const { userRole } = useUserRole();
  const [documentType, setDocumentType] = useState("Local");
  const [companyDocumentType, setCompanyDocumentType] = useState(false);
  const [isIframeLoaded, setIsIframeLoaded] = useState(false);
  const [isFilledStatus, setIsFilledStatus] = useState(false);
  const [companyDocumentUrl, setCompanyDocumentUrl] = useState("");
  const [checkExtension, setCheckExtension] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [htmlDoc, setHtmlDoc] = useState(null);
  const [flag, setFlag] = useState(false);
  const [consentFormModal, setConsentFormModal] = useState(false);
  const [openReason, setOpenReason] = useState(false);
  const [acceptedForm, setAcceptedForm] = useState(false);
  const [docValues, setDocValues] = useState({});
  const [companyDocId, setCompanyDocId] = useState("");
  const [rejectReason, setRejectReason] = useState("");
  const [rejectDisable, setRejectDisable] = useState(false);
  const [concentUrl, setConcentUrl] = useState("");
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [rehireDetails, setRehireDetails] = useState(null);
  const [aiRemarks, setAIRemarks] = useState([]);
  const [dynamicInterviews, setDynamicInterviews] = useState([]);
  const [interviews, setInterviews] = useState([]);
  const [pdfRejectData, setPdfRejectData] = useState({
    id: "",
    fieldName: "",
    rejectContent: "",
  });
  const { filledData } = useLegalPrifilledData();
  const [s3Files, setS3Files] = useState({
    candidatePhoto: "",
    candidateSignature: "",
    aadharCardImage: "",
    panCardImage: "",
    joining_photo: "",
    joining_sign: "",
  });

  const [permissions, setPermissions] = useState({
    canViewDocuments: false,
    canOnboard: false,
    canAdhaarAcceptReject: false,
    canPanAcceptReject: false,
    canDocImagesAcceptReject: false,
    canBankAcceptReject: false,
    canBankVerifyButton: false,
    canCandidateInfoAcceptReject: false,
    canProfessionalExpAcceptReject: false,
    canFormSubmit: false,
    canFinalApprove: false,
  });

  const checkPermissions = async () => {
    const role = localStorage.getItem("user.role");
    if (!role) return;

    const checks = [
      { entityType: "documents_module", permission: "view_documents" },
      { entityType: "documents_module", permission: "onboard" },
      { entityType: "documents_module", permission: "adhaar_verification_accept_reject" },
      { entityType: "documents_module", permission: "pan_verification_accept_reject" },
      { entityType: "documents_module", permission: "doc_images_accept_reject" },
      { entityType: "documents_module", permission: "bank_verification_accept_reject" },
      { entityType: "documents_module", permission: "bank_verification_button" },
      { entityType: "documents_module", permission: "candidate_info_accept_reject" },
      { entityType: "documents_module", permission: "professional_exp_accept_reject" },
      { entityType: "documents_module", permission: "candidate_document_form_submit" },
      { entityType: "documents_module", permission: "final_approve" },
    ];

    try {
      const results = await checkBulkPermissions(role, checks);
      const isAllowed = (perm) => results.find((r) => r.permission === perm)?.allowed || false;

      setPermissions({
        canViewDocuments: isAllowed("view_documents"),
        canOnboard: isAllowed("onboard"),
        canAdhaarAcceptReject: isAllowed("adhaar_verification_accept_reject"),
        canPanAcceptReject: isAllowed("pan_verification_accept_reject"),
        canDocImagesAcceptReject: isAllowed("doc_images_accept_reject"),
        canBankAcceptReject: isAllowed("bank_verification_accept_reject"),
        canBankVerifyButton: isAllowed("bank_verification_button"),
        canCandidateInfoAcceptReject: isAllowed("candidate_info_accept_reject"),
        canProfessionalExpAcceptReject: isAllowed("professional_exp_accept_reject"),
        canFormSubmit: isAllowed("candidate_document_form_submit"),
        canFinalApprove: isAllowed("final_approve"),
      });
    } catch (err) {
      console.error("Permission check failed:", err);
    }
  };

  const toggle = () => setModal(!modal);
  const toggleBank = () => setBankModal(!bankModal);

  const handleAlert = () => {
    if (toggleAlert) {
      swal({
        title: "Are you sure?",
        text: "Are you sure that you want to leave this Form?",
        icon: "warning",
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          window.location.reload();
        } else {
          window.location.reload();
        }
      });
    } else {
      console.log("nooooooooo jhnsdjmhbsadnb vzjhvb");
    }
  };

  const getCandidateDetails = async () => {
    setLoading(true);
    try {
      const result = await api.get(`/candidates/${id.split("?")[0]}`, {
        tokenType: "user",
      });
      result.data?.responses.forEach((element) => {
        if (element.label === "Date of Birth") {
          result.data.DOB = element.value;
        }

        if (element.label === "Phone Number") {
          result.data.mobileNo = element.value;
        }
      });
      setDocumentType(result.data.documentType);
      setBusinessType(result?.data?.trf?.businessType?.toLowerCase());
      setCompanyDocumentType(result.data.isJoiningDocumentS3);
      const img = await getImage(result?.data?.candidatePhoto?.[0]?.path);
      setS3Files({
        ...s3Files,
        candidatePhoto: img,
      });
      setCandidateDetails(result.data);
      return result.data;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const getAadharAndPanDetails = async () => {
    setLoading(true);

    let aadhar = null;
    let pan = null;
    let bank = null;

    try {
      const result = await api.get(
        `/candidateDocuments/documentVerificationDetails/candidate/${id.split("?")[0]
        }`,
        { tokenType: "user" },
      );
      if (Array.isArray(result?.data)) {
        result?.data.map((details) => {
          if (details.documentType === "Aadhar_Card") {
            aadhar = details;
            setAadharDetails(details);
          } else if (details.documentType === "Bank_Verification") {
            bank = details;
            setBankDetails(details);
          } else if (details.documentType === "Pan_Card") {
            pan = details;
            setPanDetails(details);
          }
        });
      }
      return { aadhar, bank, pan };
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  // const getJoiningFormFiltered = async () => {
  //   try {
  //     const forms = await api.get(
  //       `/companyDocuments/candidateDocuments/${id.split("?")[0]}`,
  //       {
  //         tokenType: "user",
  //       },
  //     );
  //     setJoiningForms([
  //       ...forms.data.filter(
  //         (joining) =>
  //           joining.formType === "Joining" &&
  //           !isDeclarationDocument(joining),
  //       ),
  //     ]);
  //     setLegalJoiningForms([
  //       ...forms.data.filter(
  //         (joining) =>
  //           joining.formType === "Legal" &&
  //           joining.isDocActive === true &&
  //           !isDeclarationDocument(joining),
  //       ),
  //     ]);
  //     return;
  //   } catch (err) {
  //     console.log(err);
  //     return err;
  //   }
  // };

  const getJoiningFormFiltered = async () => {
    try {
      const forms = await api.get(
        `/companyDocuments/candidateDocuments/${id.split("?")[0]}`,
        {
          tokenType: "user",
        },
      );
      setJoiningForms([
        ...forms.data.filter((joining) => joining.formType === "Joining"),
      ]);
      setLegalJoiningForms([
        ...forms.data.filter(
          (joining) =>
            joining.formType === "Legal" && joining.isDocActive === true,
        ),
      ]);
      return;
    } catch (err) {
      console.log(err);
      return err;
    }
  };


  const fetchOfferLetter = async (_id) => {
    try {
      const { data } = await api.get(`/offerLetter/${_id}`, {
        tokenType: "user",
      });
      setOfferLetterSended(data?.OffetLetter);
    } catch (err) {
      console.log(err);
    }
  };

  // const getAllJoiningFilledForms = async () => {
  //   try {
  //     const forms = await api.get(
  //       `/companyDocuments/DocumentMaping/candidateId/${id.split("?")[0]}`,
  //       { tokenType: "user" },
  //     );
  //     let dataJoining = [];
  //     let dataLegal = [];
  //     let dataDeclaration = [];
  //     let dataChecklist = [];
  //     let joiningCount = 0;
  //     let checklistCount = 0;
  //     let legalCount = 0;
  //     let declarationCount = 0;
  //     for (let i = 0; i < forms?.data?.length; i++) {
  //       if (isDeclarationDocument(forms?.data[i])) {
  //         declarationCount++;
  //         dataDeclaration.push({
  //           sno: declarationCount,
  //           formName:
  //             forms?.data[i]?.companyDocumentId?.companyDocumentNamesId
  //               ?.documentName || forms?.data[i]?.companyDocumentId.formName,
  //           approve:
  //             forms?.data[i]?.formStatusByHR === true
  //               ? formatDateDDMMYYYY(new Date(forms?.data[i]?.updatedAt))
  //               : "",
  //           status:
  //             forms?.data[i]?.isFilledStatus === false &&
  //               forms?.data[i]?.formStatusByHR === null ? (
  //               <Pending />
  //             ) : (
  //               <>
  //                 {forms?.data[i]?.formStatusByHR === false ? (
  //                   <Rejected />
  //                 ) : (
  //                   <>
  //                     {forms?.data[i]?.isFilledStatus === true ||
  //                       forms?.data[i]?.formStatusByHR === true ? (
  //                       <Accepted />
  //                     ) : (
  //                       <ReadyForReview />
  //                     )}
  //                   </>
  //                 )}
  //               </>
  //             ),
  //           action: forms?.data[i],
  //         });
  //       } else if (forms?.data[i]?.companyDocumentId.formType === "Joining") {
  //         joiningCount++;
  //         dataJoining.push({
  //           sno: joiningCount,
  //           formName:
  //             forms?.data[i]?.companyDocumentId?.companyDocumentNamesId
  //               ?.documentName || forms?.data[i]?.companyDocumentId.formName,
  //           approve: formatDateDDMMYYYY(new Date(forms?.data[i]?.updatedAt)),
  //           status:
  //             forms?.data[i]?.isFilledStatus === false &&
  //               forms?.data[i]?.formStatusByHR === null ? (
  //               <Pending />
  //             ) : (
  //               <>
  //                 {(forms?.data[i]?.formStatusByHR === null ||
  //                   forms?.data[i]?.formStatusByHR === false) &&
  //                   forms?.data[i]?.isFilledStatus === true ? (
  //                   <ReadyForReview />
  //                 ) : (
  //                   <>
  //                     {forms?.data[i]?.formStatusByHR ? (
  //                       <Verified />
  //                     ) : (
  //                       <Rejected />
  //                     )}
  //                   </>
  //                 )}
  //               </>
  //             ),
  //           action: forms?.data[i],
  //         });
  //       } else if (forms?.data[i]?.companyDocumentId.formType === "Checklist") {
  //         checklistCount++;
  //         dataChecklist.push({
  //           sno: checklistCount,
  //           formName:
  //             forms?.data[i]?.companyDocumentId?.companyDocumentNamesId
  //               ?.documentName || forms?.data[i]?.companyDocumentId.formName,
  //           approve: formatDateDDMMYYYY(new Date(forms?.data[i]?.updatedAt)),
  //           status:
  //             forms?.data[i]?.isFilledStatus === false &&
  //               forms?.data[i]?.formStatusByHR === null ? (
  //               <Pending />
  //             ) : (
  //               <>
  //                 {(forms?.data[i]?.formStatusByHR === null ||
  //                   forms?.data[i]?.formStatusByHR === false) &&
  //                   forms?.data[i]?.isFilledStatus === true ? (
  //                   <ReadyForReview />
  //                 ) : (
  //                   <>
  //                     {forms?.data[i]?.formStatusByHR ? (
  //                       <Verified />
  //                     ) : (
  //                       <Rejected />
  //                     )}
  //                   </>
  //                 )}
  //               </>
  //             ),
  //           action: forms?.data[i],
  //         });
  //       } else if (
  //         forms?.data[i]?.companyDocumentId.formType === "Legal" &&
  //         forms?.data[i]?.companyDocumentId.isDocActive === true
  //       ) {
  //         legalCount++;
  //         dataLegal.push({
  //           sno: legalCount,
  //           formName: forms?.data[i]?.companyDocumentId.formName,
  //           approve: formatDateDDMMYYYY(new Date(forms?.data[i]?.updatedAt)),
  //           status:
  //             forms?.data[i]?.isFilledStatus === false &&
  //               forms?.data[i]?.formStatusByHR === null ? (
  //               <Pending />
  //             ) : (
  //               <>
  //                 {(forms?.data[i]?.formStatusByHR === null ||
  //                   forms?.data[i]?.formStatusByHR === false) &&
  //                   forms?.data[i]?.isFilledStatus === true ? (
  //                   <ReadyForReview />
  //                 ) : (
  //                   <>
  //                     {forms?.data[i]?.formStatusByHR ? (
  //                       <Verified />
  //                     ) : (
  //                       <Rejected />
  //                     )}
  //                   </>
  //                 )}
  //               </>
  //             ),
  //           action: forms?.data[i],
  //         });
  //       }
  //     }

  //     setFilledForms([
  //       ...forms.data.filter(
  //         (joining) =>
  //           joining?.companyDocumentId?.formType === "Joining" &&
  //           !isDeclarationDocument(joining),
  //       ),
  //     ]);
  //     setLegalFilledForms([
  //       ...forms.data.filter(
  //         (legal) =>
  //           legal?.companyDocumentId?.formType === "Legal" &&
  //           legal?.companyDocumentId?.isDocActive === true &&
  //           !isDeclarationDocument(legal),
  //       ),
  //     ]);
  //     setChecklistFilledForms([
  //       ...forms.data.filter(
  //         (legal) => legal?.companyDocumentId?.formType === "Checklist",
  //       ),
  //     ]);
  //     setOfferLetters([
  //       ...forms.data.filter(
  //         (legal) =>
  //           !isDeclarationDocument(legal) &&
  //           !["Checklist", "Legal", "Joining"].includes(
  //             legal?.companyDocumentId?.formType,
  //           ),
  //       ),
  //     ]);
  //     setJoiningTableData([...dataJoining]);
  //     setDeclarationTableData([...dataDeclaration]);
  //     setLegalTableData([...dataLegal]);
  //     setChecklistTableData([...dataChecklist]);
  //     return;
  //   } catch (err) {
  //     console.log(err);
  //     return;
  //   }
  // };

  const getAllJoiningFilledForms = async () => {
    try {
      const forms = await api.get(
        `/companyDocuments/DocumentMaping/candidateId/${id.split("?")[0]}`,
        { tokenType: "user" },
      );
      let dataJoining = [];
      let dataLegal = [];
      let dataChecklist = [];
      let joiningCount = 0;
      let checklistCount = 0;
      let legalCount = 0;
      for (let i = 0; i < forms?.data?.length; i++) {
        if (forms?.data[i]?.companyDocumentId.formType === "Joining") {
          joiningCount++;
          dataJoining.push({
            sno: joiningCount,
            formName:
              forms?.data[i]?.companyDocumentId?.companyDocumentNamesId
                ?.documentName || forms?.data[i]?.companyDocumentId.formName,
            approve: formatDateDDMMYYYY(new Date(forms?.data[i]?.updatedAt)),
            status:
              forms?.data[i]?.isFilledStatus === false &&
                forms?.data[i]?.formStatusByHR === null ? (
                <Pending />
              ) : (
                <>
                  {(forms?.data[i]?.formStatusByHR === null ||
                    forms?.data[i]?.formStatusByHR === false) &&
                    forms?.data[i]?.isFilledStatus === true ? (
                    <ReadyForReview />
                  ) : (
                    <>
                      {forms?.data[i]?.formStatusByHR ? (
                        <Verified />
                      ) : (
                        <Rejected />
                      )}
                    </>
                  )}
                </>
              ),
            action: forms?.data[i],
          });
        } else if (forms?.data[i]?.companyDocumentId.formType === "Checklist") {
          checklistCount++;
          dataChecklist.push({
            sno: checklistCount,
            formName:
              forms?.data[i]?.companyDocumentId?.companyDocumentNamesId
                ?.documentName || forms?.data[i]?.companyDocumentId.formName,
            approve: formatDateDDMMYYYY(new Date(forms?.data[i]?.updatedAt)),
            status:
              forms?.data[i]?.isFilledStatus === false &&
                forms?.data[i]?.formStatusByHR === null ? (
                <Pending />
              ) : (
                <>
                  {(forms?.data[i]?.formStatusByHR === null ||
                    forms?.data[i]?.formStatusByHR === false) &&
                    forms?.data[i]?.isFilledStatus === true ? (
                    <ReadyForReview />
                  ) : (
                    <>
                      {forms?.data[i]?.formStatusByHR ? (
                        <Verified />
                      ) : (
                        <Rejected />
                      )}
                    </>
                  )}
                </>
              ),
            action: forms?.data[i],
          });
        } else if (
          forms?.data[i]?.companyDocumentId.formType === "Legal" &&
          forms?.data[i]?.companyDocumentId.isDocActive === true
        ) {
          legalCount++;
          dataLegal.push({
            sno: legalCount,
            formName: forms?.data[i]?.companyDocumentId.formName,
            approve: formatDateDDMMYYYY(new Date(forms?.data[i]?.updatedAt)),
            status:
              forms?.data[i]?.isFilledStatus === false &&
                forms?.data[i]?.formStatusByHR === null ? (
                <Pending />
              ) : (
                <>
                  {(forms?.data[i]?.formStatusByHR === null ||
                    forms?.data[i]?.formStatusByHR === false) &&
                    forms?.data[i]?.isFilledStatus === true ? (
                    <ReadyForReview />
                  ) : (
                    <>
                      {forms?.data[i]?.formStatusByHR ? (
                        <Verified />
                      ) : (
                        <Rejected />
                      )}
                    </>
                  )}
                </>
              ),
            action: forms?.data[i],
          });
        }
      }

      setFilledForms([
        ...forms.data.filter(
          (joining) => joining?.companyDocumentId?.formType === "Joining",
        ),
      ]);
      setLegalFilledForms([
        ...forms.data.filter(
          (legal) =>
            legal?.companyDocumentId?.formType === "Legal" &&
            legal?.companyDocumentId?.isDocActive === true,
        ),
      ]);
      setChecklistFilledForms([
        ...forms.data.filter(
          (legal) => legal?.companyDocumentId?.formType === "Checklist",
        ),
      ]);
      setOfferLetters([
        ...forms.data.filter(
          (legal) =>
            !["Checklist", "Legal", "Joining"].includes(
              legal?.companyDocumentId?.formType,
            ),
        ),
      ]);
      setJoiningTableData([...dataJoining]);
      setLegalTableData([...dataLegal]);
      setChecklistTableData([...dataChecklist]);
      return;
    } catch (err) {
      console.log(err);
      return;
    }
  };

  // Separate API call for formType === 'Consent' forms only
  const getConsentForms = async () => {
    try {
      const forms = await api.get(
        `/companyDocuments/DocumentMaping/candidateId/${id.split("?")[0]}`,
        { tokenType: "user" },
      );
      let dataConsent = [];
      let consentCount = 0;
      for (let i = 0; i < forms?.data?.length; i++) {
        const formType = forms?.data[i]?.companyDocumentId?.formType || "";
        if (normalizeFormName(formType) === "consent") {
          consentCount++;
          dataConsent.push({
            sno: consentCount,
            formName:
              forms?.data[i]?.companyDocumentId?.companyDocumentNamesId
                ?.documentName || forms?.data[i]?.companyDocumentId?.formName,
            approve:
              forms?.data[i]?.formStatusByHR === true
                ? formatDateDDMMYYYY(new Date(forms?.data[i]?.updatedAt))
                : "",
            status:
              forms?.data[i]?.isFilledStatus === false &&
                forms?.data[i]?.formStatusByHR === null ? (
                <Pending />
              ) : (
                <>
                  {forms?.data[i]?.formStatusByHR === false ? (
                    <Rejected />
                  ) : (
                    <>
                      {forms?.data[i]?.isFilledStatus === true ||
                        forms?.data[i]?.formStatusByHR === true ? (
                        <Accepted />
                      ) : (
                        <ReadyForReview />
                      )}
                    </>
                  )}
                </>
              ),
            action: forms?.data[i],
          });
        }
      }
      setConsentTableData([...dataConsent]);
    } catch (err) {
      console.log(err);
    }
  };

  const getMetaData = async () => {
    try {
      const result = await api.get(
        `/candidateDocuments/candidateAllDetails/getCandidateDetails/${id.split("?")[0]
        }`,
        { tokenType: "user" },
      );
      setMetaData(result.data);
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  };

  const getUANDetails = async () => {
    if (!aadharDetails) return;
    try {
      const result = await api.get(
        `/candidateDocuments/UANHistory/${id.split("?")[0]}`,
        {
          tokenType: "user",
        },
      );
      setUanDetails(result.data);
      const { UANHistory } = result.data;
      if (
        UANHistory[0]?.documentType === "UAN_History" &&
        UANHistory[0]?.documentStatus === true
      ) {
        if (UANHistory[0]?.aadharVerificationDetails?.success) {
          const { employment_history } =
            UANHistory[0].aadharVerificationDetails.data;
          employment_history?.sort((a, b) => {
            const dateA = new Date(
              a.split("-")[1],
              getMonthIndex(a.split("-")[0]),
            );
            const dateB = new Date(
              b.split("-")[1],
              getMonthIndex(b.split("-")[0]),
            );
            return dateB - dateA;
          });
          let obj = {
            ...UANHistory[0].aadharVerificationDetails.data,
            employment_history,
          };
          setUanDetails({ ...obj });
        } else {
          setUanDetails({});
        }
      } else {
        setUanDetails({});
      }
      return true;
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  const getRehireDetails = async (id) => {
    try {
      const { data } = await api.get(
        `/candidates/rehireCandidatesByAadharCard/${id}`,
        {
          tokenType: "user",
        },
      );
      setRehireDetails(data?.RehireDetails);
    } catch (err) {
      console.error(err);
    }
  };

  const getAllAIRemarks = async (id) => {
    try {
      const { data } = await api.get(`/documentsAutomation/candidateId/${id}`, {
        tokenType: "user",
      });
      setAIRemarks(data?.logDetails);
    } catch (err) {
      console.error(err);
    }
  };

  const getDynamicInterviews = async (designationId, departmentId, candidateId) => {
    try {
      const dynamicInterviews = await api.get(
        `/competencyInterviewSetUp/competencyAllInterview/designationId/${designationId}/departmentId/${departmentId}/candidate/${candidateId}`,
        {
          tokenType: "user",
        },
      );
      const dynamic = dynamicInterviews.data?.sort(
        (a, b) => a?.interviewNo - b?.interviewNo,
      );
      let done = [];
      // let pending = [];

      dynamic.forEach((item) => {
        const Founded = interviews?.find(
          (ele) => item?._id === ele?.designationInterviewsNamesMappingId,
        );
        if (Founded) {
          // if (Founded.finished) {
          done.push({
            ...item,
            interviewDetailsBind: Founded,
          });
          // } else {
          //   pending.push({
          //     ...item,
          //     interviewDetailsBind: Founded,
          //   });
          // }
        } else {
          done.push({
            ...item,
            interviewDetailsBind: {},
          });
        }
      });
      // done.sort((a, b) => b.interviewNo - a.interviewNo);
      // pending.sort((a, b) => a.interviewNo - b.interviewNo);
      // const final = [...pending, ...done];
      setDynamicInterviews(done);
    } catch (err) {
      console.log(err);
    }
  };

  const getInterviews = async (_id) => {
    try {
      const interviews = await api.put(
        `/interviews`,
        {
          candidate: _id,
        },
        {
          tokenType: "user",
        },
      );
      setInterviews(interviews.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getUANDetails();
  }, [aadharDetails]);

  useEffect(() => {
    const getAllData = async () => {
      setLoading(true);
      const [app] = await Promise.all([
        getCandidateDetails(),
        getAadharAndPanDetails(),
        getMetaData(),
        getAllJoiningFilledForms(),
        getConsentForms(),
        getAllAIRemarks(id.split("?")[0]),
        fetchOfferLetter(id.split("?")[0]),
      ]);

      if (app?.trf) {
        const IS_NON_AGENT =
          app?.trf?.candidateType === "Non-Agent" ? true : false;
        if (IS_NON_AGENT) {
          await getDynamicInterviews(
            app?.trf?.designationId,
            app?.trf?.departmentId,
            app?._id
          );
        }
        await getInterviews(app?._id);
      }

      if (app?.aadharNoFilled) {
        getRehireDetails(app?._id);
      }

      if (app?.empId) {
        await Promise.all([getJoiningFormFiltered()]);
      }
      setLoading(false);
    };
    getAllData();
    checkPermissions();
  }, []);

  const onBlurHandler = () => {
    setToggleAlert(true);
  };

  const getCandidateFormsList = async () => {
    try {
      const result = await api.get(
        `/candidateDocuments/candidate/${id.split("?")[0]}`,
        {
          tokenType: "user",
        },
      );
      setFormList(result?.data?.candidateDocumentDetails);
    } catch (err) {
      console.log(err);
    }
  };

  // const [imageLink, setImageLink] = useState();

  useEffect(() => {
    getCandidateFormsList();
  }, [refresh]);

  const viewDocument = (filedata, img = "") => {
    if (documentType === "S3" && BASE.storageType && img) {
      setS3Preview(img);
      setCheckExtension(filedata?.filename?.split(".")[1]?.toLowerCase());
      setDownloadLink(img);
    } else {
      const link = url("/uploads/") + filedata?.filename;
      setCheckExtension(filedata?.filename.split(".")[1]?.toLowerCase());
      setDownloadLink(link);
      const docLINK = [
        {
          uri: link,
        },
      ];
      setDocs(docLINK);
    }
    setHeaderModal(filedata.fieldname);
  };

  const handleApprove = async (id, fieldName) => {
    try {
      setLoading(true);
      await api.put(
        `/candidateDocuments/candidateDocumentStatus/approved`,
        { fieldName: fieldName, documentId: id, DocumentStatusName: true },
        { tokenType: "user" },
      );
      setRefresh(!refresh);
    } catch (err) {
      console.log(err);
      setRefresh(!refresh);
    } finally {
      setLoading(false);
    }
  };

  const handleReject = async () => {
    try {
      setLoading(true);
      await api.put(
        `/candidateDocuments/candidateDocumentStatus/Invalid`,
        {
          fieldName: pdfRejectData.fieldName,
          documentId: pdfRejectData.id,
          DocumentStatusName: true,
          rejectionReason: pdfRejectData.rejectContent,
        },
        { tokenType: "user" },
      );
      setDocumentModal(!documentModal);
      setPdfRejectData({
        ...pdfRejectData,
        rejectContent: "",
      });
      setRefresh(!refresh);
    } catch (err) {
      setRefresh(!refresh);
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const approveAll = async (id) => {
    try {
      setLoading(true);
      await api.put(
        `/candidateDocuments/submitDocumentStatus/${id.split("?")[0]}`,
        {
          status: true,
          rejectionReason: null,
        },
        { tokenType: "user" },
      );
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setRefresh(!refresh);
    }
  };

  const showDrawer = () => {
    setOpen(true);
    setRefresh(!refresh);
  };

  const onClose = () => {
    setOpen(false);
    setRefresh(!refresh);
  };

  const hideApprovebtn = (ele) => {
    if (ele?.responses?.length === 0) {
      return false;
    }
    const allApproved = ele?.files?.every((file) => file?.approved === true);
    return allApproved;
  };

  const hideFinalApprovebtn = () => {
    if (permissions.canFinalApprove) {
      return true;
    }
    if (["hr"].includes(userRole) && candidateDetails?.empIdCreatedDate) {
      // const twoDayAfter = moment(candidateDetails?.empIdCreatedDate).add(3,'d')
      // if(moment().isBefore(twoDayAfter)){
      //   return true
      // }
      // return false
      if (candidateDetails?.isApproveStatus) {
        return true;
      }
      return false;
    }
    return false;
  };

  const onRejectHandlerDoc = () => {
    axios
      .put(
        "candidateDocuments/submitDocumentStatus/" + formId,
        {
          status: false,
          rejectionReason: docRejectReason,
        },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        },
      )
      .then((res) => {
        setDocRejectModal(false);
        setDocRejectReason("");
        setOpenWarningModal(false);
      })
      .catch(console.error)
      .finally((res) => {
        setRefresh(!refresh);
      });
  };

  const getFormPreviewData = async (
    e,
    data,
    values,
    _id,
    accepted,
    formName,
    acceptedByCan,
    businessType,
    isPdfExist,
    filePath,
    formData,
  ) => {
    if (documentType === "S3" && BASE.storageType && !isPdfExist) {
      var [photo, sign] = await Promise.all([
        getImage(candidateDetails?.candidatePhoto?.[0]?.path),
        getImage(candidateDetails?.candidateSignature?.[0]?.path),
      ]);
    }
    const htmlElement = domParser.parseFromString(data, "text/html");
    if (htmlElement.getElementById("date") !== null) {
      htmlElement.getElementById("date").innerText =
        acceptedFormByCan !== ""
          ? formatDateDDMMYYYY(new Date(acceptedFormByCan))
          : formatDateDDMMYYYY(new Date());
    }
    if (htmlElement.getElementById("signature") !== null) {
      htmlElement.getElementById("signature").src =
        documentType === "S3" && BASE.storageType
          ? sign
          : url() + candidateDetails?.candidateSignature[0]?.path;
    }
    if (htmlElement.getElementById("photo") !== null) {
      htmlElement.getElementById("photo").src =
        documentType === "S3" && BASE.storageType
          ? photo
          : url() + candidateDetails?.candidatePhoto[0]?.path;
    }
    if (htmlElement.getElementById("email") !== null) {
      htmlElement.getElementById("email").innerText = candidateDetails?.email;
    }
    if (htmlElement.getElementById("emp_id") !== null) {
      htmlElement.getElementById("emp_id").innerText = candidateDetails?.empId;
    }
    if (htmlElement.getElementById("emp_id_last") !== null) {
      htmlElement.getElementById("emp_id_last").innerText =
        candidateDetails?.empId;
    }
    if (htmlElement.getElementById("mobile_number") !== null) {
      htmlElement.getElementById("mobile_number").innerText =
        candidateDetails?.mobileNo;
    }
    if (htmlElement.getElementById("address") !== null) {
      htmlElement.getElementById("address").innerText =
        aadharDetails?.aadharVerificationDetails?.data?.full_address ||
        metaData?.permanent_address?.replace(/\n/g, " ")?.trim();
    }
    if (htmlElement.getElementById("parents") !== null) {
      const fatherName =
        metaData?.father_name?.trim() ||
        aadharDetails?.aadharVerificationDetails?.data?.care_of
          ?.replace(/^[A-Za-z]+\/[A-Za-z]+:?\s+/i, "")
          .trim() ||
        "";
      htmlElement.getElementById("parents").innerText = fatherName;
    }
    if (htmlElement.getElementById("location") !== null) {
      htmlElement.getElementById("location").innerText =
        candidateDetails?.workLocation;
    }
    if (htmlElement.getElementById("designation") !== null) {
      htmlElement.getElementById("designation").innerText =
        candidateDetails?.trf?.position ? candidateDetails?.trf?.position : "";
    }
    if (htmlElement.getElementById("name") !== null) {
      htmlElement.getElementById("name").innerText = capitalizeEachWord(
        aadharDetails?.aadharVerificationDetails?.data?.full_name
          ? aadharDetails?.aadharVerificationDetails?.data?.full_name
          : candidateDetails?.name,
      );
    }
    if (htmlElement.getElementById("name_1") !== null) {
      htmlElement.getElementById("name_1").innerText = capitalizeEachWord(
        aadharDetails?.aadharVerificationDetails?.data?.full_name
          ? aadharDetails?.aadharVerificationDetails?.data?.full_name
          : candidateDetails?.name,
      );
    }
    if (htmlElement.getElementById("date_of_joining") !== null) {
      htmlElement.getElementById("date_of_joining").innerText =
        !candidateDetails?.DateOfJoining
          ? ""
          : formatDateDDMMYYYY(new Date(candidateDetails?.DateOfJoining));
    }
    if (htmlElement.getElementById("logo") !== null) {
      htmlElement.getElementById("logo").src = LOGOS[businessType];
    }

    const form = htmlElement.getElementById("willing_form");
    const checklist = htmlElement.getElementById("checklist_form");

    if (form !== null && values) {
      for (var i = 0; i < form.elements.length; i++) {
        var element = form.elements[i];
        if (element.nodeName === "INPUT" && element.hasAttribute("name")) {
          element.placeholder = values[element.getAttribute("name")]
            ? values[element.getAttribute("name")]
            : "";
          element.disabled = true;
        }
      }
    }

    if (checklist !== null && values) {
      Object.keys(values).forEach((id) => {
        const element = htmlElement.getElementById(id);
        if (element) {
          htmlElement.getElementById(id).innerText = "✓";
          htmlElement.getElementById(id).nextElementSibling.style.display =
            "none";
        }
      });
    }

    if (companyDocumentType) {
      if (!isPdfExist && formData?.isFilledStatus) {
        const parentTable = htmlElement.querySelector(".parent");

        const wef = formData?.companyDocumentId?.WEF
          ? `W.E.F : ${formatDDMMYYYY(
            new Date(formData?.companyDocumentId?.WEF),
          )}`
          : htmlElement.getElementById("wef")?.innerText;
        const docNumber = formData?.companyDocumentId?.docNo
          ? `DOC NO : ${formData?.companyDocumentId?.docNo}`
          : htmlElement.getElementById("doc_number")?.innerText;
        const revisionNumber = formData?.companyDocumentId?.revNo
          ? `REV. NO : ${formData?.companyDocumentId?.revNo}`
          : htmlElement.getElementById("rev_number")?.innerText;
        const docName =
          formData?.companyDocumentId?.companyDocumentNamesId?.documentName ||
          formName;

        const rows = Array.from(parentTable.childNodes[1].children);
        const newRows = Array.from(parentTable.childNodes[1].children).slice(1);
        rows.forEach((row) => {
          row.parentNode.removeChild(row);
        });
        newRows.forEach((row) => {
          parentTable.childNodes[1].appendChild(row);
        });

        try {
          setLoading(true);
          const result = await api.post(
            `/companyDocuments/htmltoPdf`,
            {
              wef,
              formName: docName,
              companyDocumentId: _id,
              candidateId: id.split("?")[0],
              docNumber,
              companyName: businessType,
              revisionNumber,
              html: `<div id="container" class="formContainer"> 
              ${htmlElement.getElementById("container").innerHTML}
            </div>`,
            },
            { tokenType: "user" },
          );
          setCompanyDocumentUrl(result.data);
          await getAllJoiningFilledForms();
        } catch (err) {
          console.log(err);
        } finally {
          setLoading(false);
        }
      } else {
        const pdf_url = await getImage(filePath);
        setCompanyDocumentUrl(pdf_url);
      }
      setOpenForm((prev) => true);
    } else {
      setHtmlDoc(htmlElement.getElementById("container"));
      setOpenForm((prev) => true);
    }
    setIsFilledStatus(formData.isFilledStatus);
    setRejectDisable(formName === "Willingness Document" ? true : false);
    setCompanyDocId(_id);
    setAcceptedFormByCan(acceptedByCan);
    setAcceptedForm(accepted);
    setBusinessType(businessType?.toLowerCase());
    try {
      if (data) {
        setDocValues({
          ...values,
        });
        setTimeout(() => {
          setFlag((prev) => !prev);
        }, 200);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getLegalFormPreviewData = async (
    e,
    data,
    values,
    _id,
    accepted,
    formName,
    acceptedByCan,
    isPdfExist,
    filePath,
    _isFilledStatus,
  ) => {
    if (!isPdfExist && _isFilledStatus) {
      if (documentType === "S3" && BASE.storageType) {
        var [photo, sign] = await Promise.all([
          getImage(candidateDetails?.candidatePhoto[0].path),
          getImage(candidateDetails?.candidateSignature[0].path),
        ]);
      }

      let logoBase = "";
      if (formName === "Accidental Form") {
        logoBase = ACCIDENTAL;
      } else if (formName === "Mediclaim Form") {
        logoBase = MEDICLAIM;
      } else if (formName === "ESI Form") {
        logoBase = ESI_LOGO;
      } else if (formName === "Form 11" || formName === "EPF Form") {
        logoBase = FORM_11;
      }

      const _html = domParser.parseFromString(data, "text/html");

      const previewHtml = filledData(
        _html,
        values,
        candidateDetails,
        photo,
        sign,
        documentType,
        logoBase,
      );

      try {
        setLoading(true);
        const result = await api.post(
          `/companyDocuments/htmltoPdfLegalForm`,
          {
            formName,
            companyDocumentId: _id,
            candidateId: id.split("?")[0],
            html: `<div id="container" class="leagle"> 
            ${previewHtml.getElementById("container").innerHTML}
          </div>`,
          },
          { tokenType: "user" },
        );
        setCompanyDocumentUrl(result.data);
        await getAllJoiningFilledForms();
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    } else {
      const pdf_url = await getImage(filePath);
      setCompanyDocumentUrl(pdf_url);
    }
    setIsFilledStatus(_isFilledStatus);
    setOpenForm((prev) => true);
    setRejectDisable(true);
    setCompanyDocId(_id);
    setAcceptedFormByCan(acceptedByCan);
    setAcceptedForm(accepted);
  };

  const handlePrint = async () => {
    try {
      setLoading(true);
      const response = await fetch(companyDocumentUrl, { mode: "cors" });
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      printJS({
        printable: url,
        type: "pdf",
        onError: () => {
          message.error("Something went wront while print.", 3);
        },
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const preview = document.getElementById("preview");
    if (preview !== null && htmlDoc !== null) {
      preview.appendChild(htmlDoc);
    }

    return () => {
      if (preview !== null && htmlDoc !== null) {
        preview.removeChild(htmlDoc);
      }
    };
  }, [htmlDoc, openForm, flag]);

  const joiningColumns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      sorter: (a, b) => a.sno > b.sno,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.sno.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Form Name",
      dataIndex: "formName",
      key: "formName",
      sorter: (a, b) => a.formName > b.formName,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.formName.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Approved On",
      dataIndex: "approve",
      key: "approve",
      sorter: (a, b) => a.approve > b.approve,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.approve.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (val, record) => {
        return (
          <>
            <button
              className="btn-sm btn-primary"
              onClick={(e) => {
                getFormPreviewData(
                  e,
                  record.action.companyDocumentId.formData,
                  record.action.documentDetails,
                  record.action._id,
                  record.action.formStatusByHR,
                  record.action.companyDocumentId.formName,
                  record.action.createdAt,
                  record.action.companyDocumentId.businessType,
                  record.action.isPdfExist,
                  record.action.filePath,
                  record.action,
                );
                setIsIframeLoaded(false);
              }}
            >
              View
            </button>
          </>
        );
      },
    },
  ];

  const legalColumns = [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      sorter: (a, b) => a.sno > b.sno,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.sno.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Form Name",
      dataIndex: "formName",
      key: "formName",
      sorter: (a, b) => a.formName > b.formName,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.formName.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Approved On",
      dataIndex: "approve",
      key: "approve",
      sorter: (a, b) => a.approve > b.approve,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.approve.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (val, record) => {
        return (
          <>
            <button
              className="btn-sm btn-primary"
              onClick={(e) => {
                getLegalFormPreviewData(
                  e,
                  record.action.companyDocumentId.formData,
                  record.action.documentDetails,
                  record.action._id,
                  record.action.formStatusByHR,
                  record.action.companyDocumentId.formName,
                  record.action.createdAt,
                  record.action.isPdfExist,
                  record.action.filePath,
                  record.action.isFilledStatus,
                );
                setIsIframeLoaded(false);
              }}
            >
              View
            </button>
          </>
        );
      },
    },
  ];

  const declarationColumns = legalColumns
    .filter(({ key }) => key !== "sno")
    .map((column) =>
      column.key === "approve" ? { ...column, title: "Accepted On" } : column,
    );

  // const checkBankNameValidation = async (aadharName, bankName) => {
  //   try {
  //     const { data } = await api.put(
  //       `/candidatedocuments/verifyAccount/HolderName`,
  //       {
  //         aadharName: aadharName,
  //         accountHolderName: bankName,
  //       },
  //       { tokenType: "user" }
  //     );

  //     return data?.name;
  //   } catch (err) {
  //     console.log(err);
  //     throw err;
  //   }
  // };

  useEffect(() => {
    var form = document.getElementById("willing_form");
    if (form !== null) {
      for (var i = 0; i < form.elements.length; i++) {
        var element = form.elements[i];
        if (element.nodeName === "INPUT" && element.hasAttribute("name")) {
          element.value = docValues[element.getAttribute("name")]
            ? docValues[element.getAttribute("name")]
            : "";
          element.disabled = true;
        }
      }
    }
  }, [htmlDoc, docValues, loading]);

  const acceptFormHandler = async (e) => {
    setLoading(true);
    setErrorMessage("");
    try {
      const { data } = await api.put(
        `/companyDocuments/CandidateDocumentStatusByHR`,
        {
          id: companyDocId,
          userId: localStorage.getItem("user.id"),
          formStatusByHR: true,
          remarks: null,
        },
        { tokenType: "user" },
      );
      await getAllJoiningFilledForms();
      setLoading(false);

      const error = data?.OCR?.response?.error;
      const isFormAccepted = data?.companyDocuments?.formStatusByHR || false;

      setAcceptedForm(isFormAccepted);
      if (error) {
        return setErrorMessage(error);
      }
      setOpenForm(false);
    } catch (err) {
      console.log(err);
      message.error(err.response.data.error.message, 3);
      setLoading(false);
    }
  };

  const onRejectHandler = async (e) => {
    setLoading(true);
    try {
      const data = await api.put(
        `/companyDocuments/CandidateDocumentStatusByHR`,
        {
          id: companyDocId,
          userId: localStorage.getItem("user.id"),
          formStatusByHR: false,
          remarks: rejectReason,
        },
        { tokenType: "user" },
      );
      setLoading(false);
      setOpenForm(false);
      setRejectReason("");
      setOpenReason(!openReason);
      setErrorMessage("");
      getAllJoiningFilledForms();
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  const enableFinalApprove = () => {
    let joiningFormsCount = 0;
    let legalFormsCount = 0;

    if (joiningForms.length === 0 || legaljoiningForms.length === 0)
      return true;

    for (let data in joiningForms) {
      if (joiningForms[data].businessType === businessType) {
        if (
          candidateDetails?.candidateType?.toLowerCase() === "support" &&
          joiningForms[data]?.formName === "Willingness Document"
        ) {
          continue;
        } else {
          joiningFormsCount++;
        }
      }
    }

    for (let data in legaljoiningForms) {
      if (legalFilledForms[data]?.companyDocumentId?.formName === "ESI Form") {
        if (candidateDetails?.ESI?.toLowerCase() === "yes") {
          legalFormsCount++;
        }
      }

      if (
        legalFilledForms[data]?.companyDocumentId?.formName === "Mediclaim Form"
      ) {
        if (candidateDetails?.mediclaim?.toLowerCase() == "yes") {
          legalFormsCount++;
        }
      }

      if (
        legalFilledForms[data]?.companyDocumentId?.formName === "Gratuity Form"
      ) {
        if (candidateDetails?.gratuity?.toLowerCase() == "yes") {
          legalFormsCount++;
        }
      }

      if (legalFilledForms[data]?.companyDocumentId?.formName === "EPF Form") {
        if (candidateDetails?.EPFO?.toLowerCase() == "yes") {
          legalFormsCount++;
        }
      }

      if (
        legalFilledForms[data]?.companyDocumentId?.formName ===
        "Accidental Form"
      ) {
        if (candidateDetails?.accidental?.toLowerCase() == "yes") {
          legalFormsCount++;
        }
      }

      if (
        legalFilledForms[data]?.companyDocumentId?.formName === "Wages Form" ||
        legalFilledForms[data]?.companyDocumentId?.formName === "Form 11"
      ) {
        legalFormsCount++;
      }
    }

    if (
      joiningFormsCount === filledForms?.length &&
      legalFormsCount === legalFilledForms?.length
    ) {
      const joiningForms = filledForms?.every(
        (ele) => ele.formStatusByHR === true,
      );
      const legalJoiningForms = legalFilledForms?.every(
        (ele) => ele.formStatusByHR === true,
      );
      if (
        joiningForms &&
        legalJoiningForms &&
        candidateDetails?.empId !== "" &&
        candidateDetails?.UANnumber !== "" &&
        candidateDetails?.trf?.position !== "" &&
        candidateDetails?.DateOfJoining
      ) {
        return false;
      }
    }
    return true;
  };

  const finalApprove = async (e) => {
    swal({
      title: "Are you sure?",
      // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
      icon: "warning",
      content: {
        element: "div",
        attributes: {
          innerHTML: `
            <p style="text-align:center">Before on-boarding the candidate, please cross verify the TRF.</p>       
          `,
        },
      },
      buttons: {
        cancel: true,
        confirm: true,
      },
    }).then(async (flag) => {
      if (flag) {
        setLoading(true);
        try {
          const result = await api.put(
            `/candidateDocuments/FinalApprovedAll/${id.split("?")[0]}`,
            {
              candidateId: id.split("?")[0],
              userId: localStorage.getItem("user.id"),
            },
            { tokenType: "user" },
          );
          if (result) {
            getCandidateDetails();
            message.success(result.data, 2);
          }
          setLoading(false);
        } catch (err) {
          message.error(err.response.data.message, 2);
          console.log(err);
          setLoading(false);
        }
      } else {
        return;
      }
    });
  };

  const tempIdCreate = (e) => {
    swal({
      title: "Are you sure?",
      // text: "Are you sure you want to Approve? Before on-boarding the candidate, please cross verify the TRF.",
      icon: "warning",
      content: {
        element: "div",
        attributes: {
          innerHTML: `
            <p style="text-align:center">Before on-boarding the candidate, please cross verify the TRF.</p>       
          `,
        },
      },
      buttons: {
        cancel: true,
        confirm: true,
      },
    }).then(async (flag) => {
      if (flag) {
        setLoading(true);
        try {
          const result = await api.put(
            `/candidateDocuments/ApprovedAll/candidateId`,
            {
              candidateId: id.split("?")[0],
              userId: localStorage.getItem("user.id"),
            },
            { tokenType: "user" },
          );
          if (result) {
            getCandidateDetails();
            message.success(result.data, 2);
          }
          setLoading(false);
        } catch (err) {
          message.error(err.response.data.message, 2);
          console.log(err);
          setLoading(false);
        }
      } else {
        return;
      }
    });
  };

  console.log(candidateDetails, "PPPPPPPPPPPPPPP");

  const IS_NON_AGENT =
    candidateDetails?.trf?.candidateType === "Non-Agent" ? true : false;

  const isInterDone = () => {
    if (dynamicInterviews.length !== 0 && IS_NON_AGENT) {
      if (interviews?.length !== dynamicInterviews?.length) {
        for (let item of interviews) {
          if (item?.status === "Rejected") {
            return false;
          }
        }
        return null;
      }

      if (interviews?.length === dynamicInterviews?.length) {
        const isSelected = interviews?.every(
          (item) => item?.status === "Selected",
        );
        if (isSelected) {
          return true;
        }

        return null;
      }
    } else {
      const versantInterview = interviews?.find(
        (item) => item?.type === "versant",
      );
      const isClientRoundExist = versantInterview?.clientRoundExist;
      const isVersantNotRequired = versantInterview?.isVersantNotRequired;

      if (isClientRoundExist) {
        if (interviews.length === 4) {
          const isSelected = interviews?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return true;
          }
        } else {
          return null;
        }
      } else {
        if (interviews.length === 3) {
          const isSelected = interviews?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return true;
          }
        } else if (interviews.length === 4 && isVersantNotRequired) {
          const isSelected = interviews?.every(
            (item) => item?.status === "Selected",
          );
          if (isSelected) {
            return true;
          }
        } else {
          return null;
        }
      }
      return null;
    }
  };

  const enableTempIdCreation = () => {

    if (!isInterDone()) {
      return true;
    }

    if (
      candidateDetails?.aadharStatus &&
      candidateDetails?.aadharCardNo !== "" &&
      aadharDetails?.documentStatus &&
      candidateDetails?.panStatus &&
      (candidateDetails?.panCardNo !== "" ||
        candidateDetails?.acknowledgementNo !== "") &&
      (panDetails?.documentStatus || candidateDetails?.acknowledgementStatus) &&
      candidateDetails?.candidateSignatureStatus &&
      candidateDetails?.candidatePhotoStatus &&
      candidateDetails?.concentStatus
    ) {
      const documents = formList?.every((ele) => ele.documentStatus === true);
      if (documents) {
        return false;
      }
    }

    return true;
  };

  const bankVerify = async (elements, _id) => {
    let accNo = "";
    let IFSC = "";
    try {
      if (elements.length !== 0) {
        elements?.map((ele) => {
          if (ele?.label?.trim().toLowerCase() === "ifsc code") {
            IFSC = ele?.value || "";
          }

          if (ele?.label?.trim().toLowerCase() === "bank account number") {
            accNo = ele?.value || "";
          }
        });
      }
      setLoading(true);
      const { data } = await api.put(
        `/candidateDocuments/verifyBankDetails/${id.split("?")[0]}`,
        {
          candidateDocumentId: _id,
          accNo,
          IFSC,
        },
        {
          tokenType: "user",
        },
      );

      await getAadharAndPanDetails();
      if (data?.OCR?.response?.error) {
        setBankErrorMessage(data?.OCR?.response?.error);
        setOpenWarningModal(true);
      }
      // const status = await checkBankNameValidation(
      //   aadhar?.aadharVerificationDetails?.data?.full_name || "",
      //   bank?.aadharVerificationDetails?.data?.full_name || ""
      // );

      console.log(data, "API Result");
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setRefresh(!refresh);
    }
  };

  const breadcrumbs = [
    {
      label: "Documents",
      url: `/documents/candidates`,
    },
    {
      label: candidateDetails?.name,
      url: "",
    },
  ];

  if (!permissions.canViewDocuments) return <div></div>;

  return (
    <Dashboard title="Document Verification">
      {(loading || imageLoad) && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <>
        <Header
          candidate={candidateDetails}
          setLoad={setLoading}
          breadcrumbs={breadcrumbs}
          isShowControl={false}
          rehireDetails={rehireDetails}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
          className="row p-3 border mb-2 bg-white cursor-pointer"
        >
          <div className="flex flex-column gap-2 align-items-center p-0 my-lg-0 my-2">
            {candidateDetails?.candidatePhoto &&
              candidateDetails?.candidatePhoto?.length !== 0 ? (
              // <img
              //   // src="https://mdbcdn.b-cdn.net/img/new/avatars/2.webp"
              //   src={url(imageLink)}
              //   className="rounded-circle"
              //   style={{ width: 100, height: 100 }}
              //   alt="Avatar"
              // />
              <>
                {candidateDetails?.candidatePhoto && (
                  <img
                    style={{
                      width: 100,
                      height: 100,
                      border: "1px solid #fd7e14",
                    }}
                    className="img rounded-circle"
                    src={
                      documentType === "S3" && BASE.storageType
                        ? s3Files?.candidatePhoto
                        : url() + candidateDetails?.candidatePhoto[0]?.path
                    }
                    alt="profile"
                  />
                )}
              </>
            ) : (
              <img
                src="https://mdbcdn.b-cdn.net/img/new/avatars/2.webp"
                //src={url("/uploads/") + candidate.files[0].filename}
                className="rounded-circle"
                style={{ width: 100, height: 100 }}
                alt="Avatar"
              />
            )}
            <h6 className="font-weight-bold mb-1">
              {formList[0]?.candidateId?.name}
            </h6>
          </div>
          <div className="d-flex align-items-center gap-1">
            <button onClick={showDrawer} className="btn btn-primary">
              View Documents
            </button>
            {candidateDetails?.documentsVerifiedStatus ? (
              candidateDetails?.IsSelected ? (
                <button
                  style={{ background: "green", color: "#fff" }}
                  className={`btn`}
                >
                  Onboarded
                </button>
              ) : (
                <button
                  style={{ background: "skyblue", color: "#fff" }}
                  className={`btn`}
                >
                  Ready For Onboaring
                </button>
              )
            ) : (
              <>
                {candidateDetails?.isEmpTempIdCreated && (
                  <>
                    {hideFinalApprovebtn() && (
                      <div className="d-flex gap-1">
                        {permissions.canFinalApprove && (
                          <button
                            className={`btn ${enableFinalApprove() ? "btn-secondary" : "btn-primary"
                              }`}
                            disabled={enableFinalApprove()}
                            onClick={finalApprove}
                          >
                            Final Approve
                          </button>
                        )}
                      </div>
                    )}
                  </>
                )}
                {!candidateDetails?.isEmpTempIdCreated && (
                  <>
                    {permissions.canOnboard && (
                      <button
                        className={`btn ${enableTempIdCreation() ? "btn-secondary" : "btn-primary"
                          }`}
                        disabled={enableTempIdCreation()}
                        onClick={tempIdCreate}
                      >
                        Create Temp ID
                      </button>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <div className="row">
          <AadharCardSection
            aadharDetails={aadharDetails}
            candidateDetails={candidateDetails}
            s3Files={s3Files}
            setLoading={setLoading}
            getCandidateDetails={getCandidateDetails}
            getAadharAndPanDetails={getAadharAndPanDetails}
            aiRemarks={aiRemarks}
            canAcceptReject={permissions.canAdhaarAcceptReject}
          />
        </div>
        <div className="row">
          <PanCardSection
            panDetails={panDetails}
            candidateDetails={candidateDetails}
            s3Files={s3Files}
            setLoading={setLoading}
            getCandidateDetails={getCandidateDetails}
            getAadharAndPanDetails={getAadharAndPanDetails}
            aiRemarks={aiRemarks}
            canAcceptReject={permissions.canPanAcceptReject}
          />
        </div>
        <div className="row">
          <Card
            className="border bg-white col-md-12 mb-2"
            title={`Signature And Photo Verification`}
          >
            <div className="row">
              <div className="col-md-6">
                <SignatureSection
                  candidateDetails={candidateDetails}
                  getCandidateDetails={getCandidateDetails}
                  setLoading={setLoading}
                  aiRemarks={aiRemarks}
                  canAcceptReject={permissions.canDocImagesAcceptReject}
                />
              </div>
              <div className="col-md-6">
                <PhotoSection
                  candidateDetails={candidateDetails}
                  getCandidateDetails={getCandidateDetails}
                  setLoading={setLoading}
                  aiRemarks={aiRemarks}
                  canAcceptReject={permissions.canDocImagesAcceptReject}
                />
              </div>
            </div>
          </Card>
        </div>
        <div className="row">
          <UANSection
            uanDetails={uanDetails}
            getCandidateDetails={getCandidateDetails}
            candidateDetails={candidateDetails}
            getUANDetails={getUANDetails}
            setLoading={setLoading}
          />
        </div>
        <div className="row">
          <Card
            className="border bg-white col-md-12 mb-2"
            title={`Document Forms`}
          >
            <Collapse style={{ position: "relative" }} accordion>
              {formList?.map((ele, index) => {
                const reasons = ele?.files
                  ?.map((ele) =>
                    ele?.invalid === true ? ele || "" : undefined,
                  )
                  .filter(Boolean);
                return (
                  <Panel
                    header={
                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          bottom: 0,
                          right: 0,
                          display: "flex",
                          alignItems: "center",
                          paddingLeft: "40px",
                        }}
                        onClick={handleAlert}
                      >
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            paddingRight: "20px",
                          }}
                        >
                          <strong>{`Form Name : ${ele?.formId?.name}`}</strong>
                          <div>
                            <div className="d-flex gap-1">
                              Sent On{" "}
                              {formatDateDDMMYYYY(new Date(ele.createdAt))}{" "}
                              {ele.isFilledStatus === false &&
                                ele.documentStatus === null ? (
                                <Pending />
                              ) : (
                                <>
                                  {(ele.documentStatus === null ||
                                    ele.documentStatus === false) &&
                                    ele.isFilledStatus === true ? (
                                    <ReadyForReview />
                                  ) : (
                                    <>
                                      {ele.documentStatus ? (
                                        <Verified />
                                      ) : (
                                        <Rejected />
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <div className="row">
                      {ele?.responses?.length === 0 ||
                        (ele?.documentStatus === null &&
                          ele?.isFilledStatus === false) ? (
                        <>
                          {ele?.formId?.elements?.map((e) => {
                            if (e.type !== "subheading") {
                              if (e.type === "professionalexperience") {
                                return (
                                  <div className="col-md-4 mt-1">
                                    <div className="card p-2">
                                      <strong>
                                        {" "}
                                        Professional Experience
                                        <span style={{ color: "red" }}>
                                          {e?.properties?.required ? "*" : ""}
                                        </span>
                                        :
                                      </strong>
                                      Not Filled{" "}
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div className="col-md-4 mt-1">
                                    <div className="card p-2">
                                      <strong>
                                        {" "}
                                        {e.properties.label}
                                        <span style={{ color: "red" }}>
                                          {e?.properties?.required ? "*" : ""}
                                        </span>
                                        :
                                      </strong>
                                      Not Filled{" "}
                                    </div>
                                  </div>
                                );
                              }
                            }
                          })}
                        </>
                      ) : (
                        <>
                          {ele?.responses?.map((fileDoc) => {
                            if (fileDoc?.element?.type === "file") {
                              const fileData = ele?.files?.find(
                                (file) =>
                                  file?.fieldname ===
                                  fileDoc?.element?.properties?.label,
                              );

                              if (fileData?.filled) {
                                return (
                                  <div className="col-md-4 mt-1">
                                    <div className="card p-2">
                                      <div className="flex justify-between">
                                        <strong>
                                          {fileDoc.label}
                                          <span style={{ color: "red" }}>
                                            {`${fileDoc?.element?.properties?.required ? "*" : ""} `}
                                          </span>
                                          :
                                        </strong>
                                        {showAIRemarks.includes(
                                          fileData?.documentName,
                                        ) && (
                                            <AIRemarks
                                              aiRemarks={aiRemarks}
                                              docType={fileData?.documentName}
                                            />
                                          )}
                                      </div>
                                      <div className="d-flex mt-1">
                                        {(() => {
                                          const formName = ele?.formId?.name?.trim().toLowerCase();
                                          if (formName === "bank details") return permissions.canBankAcceptReject;
                                          if (formName === "candidate information form") return permissions.canCandidateInfoAcceptReject;
                                          if (formName === "professional experience") return permissions.canProfessionalExpAcceptReject;
                                          return permissions.canFormSubmit;
                                        })() && (
                                            <>
                                              <Button
                                                disabled={
                                                  fileData?.approved ||
                                                  ele.documentStatus
                                                }
                                                title="accept"
                                                shape="circle"
                                                type="success"
                                                size="small"
                                                icon={<CheckOutlined />}
                                                style={{ marginRight: "4px" }}
                                                onClick={() =>
                                                  handleApprove(
                                                    ele._id,
                                                    fileData?.fieldname,
                                                  )
                                                }
                                              ></Button>
                                              <Button
                                                disabled={
                                                  fileData?.approved ||
                                                  ele.documentStatus
                                                }
                                                title="reject"
                                                shape="circle"
                                                type="danger"
                                                size="small"
                                                icon={<CloseOutlined />}
                                                style={{ marginRight: "4px" }}
                                                onClick={() => {
                                                  setPdfRejectData({
                                                    ...pdfRejectData,
                                                    id: ele._id,
                                                    fieldName: fileData?.fieldname,
                                                  });
                                                  setDocumentModal(!documentModal);
                                                }}
                                              ></Button>
                                            </>
                                          )}

                                        <Button
                                          title="view"
                                          shape="circle"
                                          type=""
                                          size="small"
                                          icon={<EyeOutlined />}
                                          onClick={async () => {
                                            if (
                                              documentType === "S3" &&
                                              BASE.storageType
                                            ) {
                                              const img = await getImage(
                                                fileData?.path,
                                              );
                                              viewDocument(fileData, img);
                                              toggle();
                                            } else {
                                              viewDocument(fileData);
                                              toggle();
                                            }
                                          }}
                                          style={{
                                            marginRight: "4px",
                                          }}
                                        ></Button>
                                      </div>
                                    </div>
                                  </div>
                                );
                              } else {
                                return (
                                  <div className="col-md-4 mt-1">
                                    <div className="card p-2">
                                      <strong>{fileDoc.label} : </strong>
                                      <div className="d-flex mt-1">
                                        Not Filled
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            } else if (
                              fileDoc?.element?.type ===
                              "professionalexperience"
                            ) {
                              return (
                                <EmployeExperienceSection
                                  eles={fileDoc}
                                  canAcceptReject={permissions.canProfessionalExpAcceptReject}
                                />
                              );
                            } else {
                              return (
                                <div className="col-md-4 mt-1">
                                  <div
                                    style={{ position: "relative" }}
                                    className="card p-2"
                                  >
                                    <strong>
                                      {fileDoc.label}
                                      <span style={{ color: "red" }}>
                                        {`${fileDoc?.element?.properties?.required ? "*" : ""} `}
                                      </span>
                                      :
                                    </strong>
                                    <div className="d-flex">
                                      {fileDoc?.value ? (
                                        <>
                                          {fileDoc?.value?.toUpperCase() !==
                                            fileDoc?.value
                                            ? capitalizeEachWord(fileDoc?.value)
                                            : fileDoc?.value}
                                        </>
                                      ) : (
                                        <div className="d-flex mt-1">
                                          Not Filled
                                        </div>
                                      )}
                                    </div>
                                    {fileDoc?.element?.isEdited && (
                                      <EditedTag />
                                    )}
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-12 d-flex p-2 gap-1 align-items-center justify-content-center">
                        {ele?.formId?.name?.trim().toLowerCase() ===
                          "bank details" && (
                            <>
                              {permissions.canBankVerifyButton && (
                                <button
                                  onClick={(e) => {
                                    bankVerify(ele?.responses, ele._id);
                                  }}
                                  className={`btn-sm ${!hideApprovebtn(ele) ||
                                    ele.documentStatus ||
                                    bankDetails?.isFilledStatus === true ||
                                    (ele?.isFilledStatus === false &&
                                      ele?.documentStatus === false)
                                    ? "btn-secondary"
                                    : "btn-primary"
                                    }`}
                                >
                                  Bank Verification
                                </button>
                              )}
                              <BankValidationPopup
                                setFormId={setFormId}
                                bankErrorMessage={bankErrorMessage}
                                docId={ele?._id}
                                openWarningModal={openWarningModal}
                                setOpenWarningModal={setOpenWarningModal}
                                aadharDetails={aadharDetails}
                                bankDetails={bankDetails}
                                setDocRejectModal={setDocRejectModal}
                                candidateDetails={candidateDetails}
                              />
                            </>
                          )}
                        {(() => {
                          const formName = ele?.formId?.name?.trim().toLowerCase();
                          if (formName === "bank details") return permissions.canBankAcceptReject;
                          if (formName === "candidate information form") return permissions.canCandidateInfoAcceptReject;
                          if (formName === "professional experience") return permissions.canProfessionalExpAcceptReject;
                          return permissions.canFormSubmit;
                        })() && (
                            <button
                              onClick={(e) => approveAll(ele._id)}
                              disabled={!hideApprovebtn(ele) || ele.documentStatus}
                              className={`btn-sm ${!hideApprovebtn(ele) || ele.documentStatus
                                ? "btn-secondary"
                                : "btn-primary"
                                }`}
                            >
                              Accept
                            </button>
                          )}
                        {(() => {
                          const formName = ele?.formId?.name?.trim().toLowerCase();
                          if (formName === "bank details") return permissions.canBankAcceptReject;
                          if (formName === "candidate information form") return permissions.canCandidateInfoAcceptReject;
                          if (formName === "professional experience") return permissions.canProfessionalExpAcceptReject;
                          return permissions.canFormSubmit;
                        })() && (
                            <button
                              onClick={(e) => {
                                setDocRejectModal(true);
                                setFormId(ele._id);
                              }}
                              disabled={
                                ele?.responses?.length === 0 ||
                                ele.documentStatus ||
                                candidateDetails?.isEmpTempIdCreated ||
                                !hideApprovebtn(ele)
                              }
                              className={`btn-sm ${ele.documentStatus ||
                                ele?.responses?.length === 0 ||
                                !hideApprovebtn(ele)
                                ? "btn-secondary"
                                : "btn-danger"
                                }`}
                            >
                              Reject
                            </button>
                          )}
                      </div>
                    </div>
                    {ele?.formId?.name?.trim().toLowerCase() ===
                      "bank details" && (
                        <div className="row">
                          {/* {!bankDetails && (
                            <div className="col-12 d-flex p-2 gap-1 align-items-center">
                              <div className="d-flex">
                                <Alert
                                  message="Status : Bank details have been verified manually by HR."
                                  type="success"
                                />
                              </div>
                            </div>
                          )} */}
                          {bankDetails && (
                            <div className="col-12 d-flex p-2 gap-1 align-items-center">
                              <div className="d-flex gap-1">
                                {bankDetails?.aadharVerificationDetails
                                  ?.success === true &&
                                  bankDetails?.aadharVerificationDetails
                                    ?.status_code === 200 &&
                                  bankDetails?.isFilledStatus && (
                                    <>
                                      <Alert
                                        message="Status : Bank details have been verified successfully with Bank."
                                        type="success"
                                      />
                                      <button
                                        onClick={toggleBank}
                                        className={`btn-sm ${"btn-primary"}`}
                                      >
                                        View More
                                      </button>
                                    </>
                                  )}

                                {bankDetails?.aadharVerificationDetails
                                  ?.success === false &&
                                  (ele.documentStatus === false ||
                                    ele.documentStatus === null) &&
                                  bankDetails?.aadharVerificationDetails
                                    ?.status_code !== 200 &&
                                  bankDetails?.isFilledStatus && (
                                    <>
                                      <Alert
                                        message={`Status : ${bankDetails?.aadharVerificationDetails?.data?.remarks}`}
                                        type="error"
                                      />
                                    </>
                                  )}

                                {/* {bankDetails?.aadharVerificationDetails
                                  ?.success === false &&
                                  bankDetails?.aadharVerificationDetails
                                    ?.status_code !== 200 && (
                                    <>
                                      <Alert
                                        message={`Status : Bank details have been verified manually by HR.`}
                                        type="success"
                                      />
                                    </>
                                  )} */}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    {ele.documentStatus !== null &&
                      ele.documentStatus === false &&
                      ele.isFilledStatus === false && (
                        <div>
                          <div className="d-flex text-danger">
                            <div className="reject_icon">
                              <i class="fa fa-close"></i>
                            </div>
                            Reason : {ele.rejectionReason}{" "}
                            {reasons
                              ?.map(
                                (ele) =>
                                  `${ele?.fieldname} - ${ele?.rejectionReason}`,
                              )
                              .join(" ")}
                          </div>
                        </div>
                      )}
                  </Panel>
                );
              })}
            </Collapse>
          </Card>
        </div>
      </>
      <Modal
        centered
        open={modal}
        onCancel={toggle}
        width={800}
        title={headerModal}
        footer={
          <div>
            <Button
              target={checkExtension === "doc" ? "" : "_blank"}
              href={downloadLink}
              type="warning"
              shape="circle"
              icon={<DownloadOutlined />}
              size="medium"
            />
          </div>
        }
      >
        {documentType === "S3" && BASE.storageType ? (
          <>
            {imgExt.includes(checkExtension) && (
              <div
                className=""
                style={{
                  width: "100%",
                  height: "700px",
                  overflowY: "auto",
                }}
              >
                <div>
                  <img
                    alt="img"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                    src={s3Preview}
                  />
                </div>
              </div>
            )}
            {videoExt.includes(checkExtension) && (
              <div>
                <video
                  style={{
                    border: "1px solid black",
                    objectFit: "cover",
                  }}
                  width="100%"
                  height="300"
                  controls
                >
                  <source src={s3Preview} />
                </video>
              </div>
            )}
            {docExt.includes(checkExtension) && (
              <div>
                <iframe
                  style={{ width: "100%" }}
                  title="iframe"
                  className="iframe"
                  width="100%"
                  height="400"
                  src={s3Preview}
                  allow="fullscreen; autoplay; clipboard-read; clipboard-write"
                >
                  <p>Iframes are not supported by your browser.</p>
                </iframe>
              </div>
            )}
          </>
        ) : (
          <DocViewer
            pluginRenderers={DocViewerRenderers}
            documents={docs}
            config={{
              header: {
                disableHeader: false,
                disableFileName: false,
                retainURLParams: false,
              },
            }}
          />
        )}
      </Modal>
      <Modal
        centered
        open={bankModal}
        onCancel={toggleBank}
        width={800}
        footer={null}
        title="Bank Verified Details"
      >
        <div className="table-responsive">
          <table id="table-datatable" className="table bg-white border">
            <tbody>
              <tr className="table-column-head">
                <td>
                  <p>
                    <b>Account Holder Name</b> :{" "}
                    {
                      bankDetails?.aadharVerificationDetails?.data?.full_name
                    }{" "}
                  </p>
                  <p>
                    <b>Bank Name</b> :{" "}
                    {
                      bankDetails?.aadharVerificationDetails?.data?.ifsc_details
                        ?.bank_name
                    }{" "}
                  </p>
                  <p>
                    <b>IFSC Code</b> :{" "}
                    {
                      bankDetails?.aadharVerificationDetails?.data?.ifsc_details
                        ?.ifsc
                    }{" "}
                  </p>
                  <p>
                    <b>Branch Name</b> :{" "}
                    {
                      bankDetails?.aadharVerificationDetails?.data?.ifsc_details
                        ?.branch
                    }{" "}
                  </p>
                  <p>
                    <b>City</b> :{" "}
                    {
                      bankDetails?.aadharVerificationDetails?.data?.ifsc_details
                        ?.city
                    }{" "}
                  </p>
                  <p>
                    <b>State</b> :{" "}
                    {
                      bankDetails?.aadharVerificationDetails?.data?.ifsc_details
                        ?.state
                    }{" "}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal>

      <Drawer
        width={800}
        title=""
        placement="right"
        onClose={onClose}
        open={open}
        zIndex={9}
      >
        <Card className="border bg-white" title="Candidate Details">
          <Collapse className="">
            <Panel header={candidateDetails?.name} key="1">
              <ResponseView responses={candidateDetails?.responses} />
            </Panel>
          </Collapse>
        </Card>
        {offerLetterSended && (
          <OfferLetter
            tokenType={"user"}
            filledForms={offerLetters}
            offerLetterSended={offerLetterSended}
            application={candidateDetails}
            loadApplication={getCandidateDetails}
            getAllJoiningFilledForms={getAllJoiningFilledForms}
          />
        )}

        <div className="row mt-4">
          <div className="col-md-12">
            <Card className="border bg-white" title="Consent Form">
              <div class="table-responsive">
                <table class="table">
                  <thead class="table-head">
                    <tr>
                      <td className="table-column-head">Form Name</td>
                      <td className="table-column-head">
                        Approved On <sub>(DD-MM-YYYY)</sub>
                      </td>
                      <td className="table-column-head">Approved Status</td>
                      <td className="table-column-head text-center">Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="table-column-head">
                        Employee Onboarding Consent
                      </td>
                      <td className="table-column-head">
                        {candidateDetails?.concentDate
                          ? formatDateDDMMYYYY(
                            new Date(candidateDetails?.concentDate),
                          )
                          : ""}
                      </td>
                      <td className="table-column-head">
                        {candidateDetails?.concentStatus ? (
                          <>
                            <Accepted />
                          </>
                        ) : (
                          <>
                            <Pending />
                          </>
                        )}
                      </td>
                      <td className="table-column-head d-flex justify-content-center">
                        <button
                          className={`btn-sm ${candidateDetails?.concentForm?.length === 0
                            ? "btn-secondary"
                            : "btn-primary"
                            }`}
                          disabled={candidateDetails?.concentForm?.length === 0}
                          onClick={async (e) => {
                            const pdfUrl = await getImage(
                              candidateDetails?.concentForm[0]?.path,
                            );
                            setConcentUrl(pdfUrl);
                            setIsIframeLoaded(false);
                            setConsentFormModal(true);
                          }}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
        </div>
        {consentTableData.length !== 0 && (
          <div className="row mt-4">
            <div className="col-md-12">
              <Card className="border bg-white" title="Declaration Form">
                <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
                  <div style={{ width: "100%" }}>
                    <Table
                      columns={declarationColumns}
                      dataSource={consentTableData}
                      pagination={false}
                      scroll={{ x: true }}
                      style={{ whiteSpace: "pre" }}
                      exportFileName="details"
                      size="small"
                    />
                  </div>
                </div>
              </Card>
            </div>
          </div>
        )}
        {candidateDetails?.empId !== "" &&
          candidateDetails?.trf?.position !== "" &&
          candidateDetails?.DateOfJoining && (
            <>
              <div className="row mt-4">
                <div className="col-md-12">
                  <Card className="border bg-white" title="Joining Forms">
                    <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
                      <div style={{ width: "100%" }}>
                        <Table
                          columns={joiningColumns}
                          dataSource={joiningTableData}
                          pagination={{
                            pageSizeOptions: [
                              "5",
                              "10",
                              "30",
                              "60",
                              "100",
                              "1000",
                            ],
                            showSizeChanger: false,
                          }}
                          scroll={{ x: true }}
                          style={{ whiteSpace: "pre" }}
                          exportFileName="details"
                          size="small"
                        />
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-12">
                  <Card className="border bg-white" title="Legal Forms">
                    <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
                      <div style={{ width: "100%" }}>
                        <Table
                          columns={legalColumns}
                          dataSource={legalTableData}
                          pagination={{
                            pageSizeOptions: [
                              "5",
                              "10",
                              "30",
                              "60",
                              "100",
                              "1000",
                            ],
                            showSizeChanger: false,
                          }}
                          scroll={{ x: true }}
                          style={{ whiteSpace: "pre" }}
                          exportFileName="details"
                          size="small"
                        />
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </>
          )}

        {candidateDetails?.empId !== "" &&
          candidateDetails?.trf?.position !== "" &&
          candidateDetails?.DateOfJoining &&
          candidateDetails?.IsSelected && (
            <>
              <div className="row mt-4">
                <div className="col-md-12">
                  <Card
                    className="border bg-white"
                    title="Policy Checklist Forms"
                  >
                    <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
                      <div style={{ width: "100%" }}>
                        <Table
                          columns={joiningColumns}
                          dataSource={checklistTableData}
                          pagination={{
                            pageSizeOptions: [
                              "5",
                              "10",
                              "30",
                              "60",
                              "100",
                              "1000",
                            ],
                            showSizeChanger: false,
                          }}
                          scroll={{ x: true }}
                          style={{ whiteSpace: "pre" }}
                          exportFileName="details"
                        />
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            </>
          )}
      </Drawer>
      <Modal
        centered
        open={openForm}
        onOk={() => {
          setOpenForm(!openForm);
          setCompanyDocumentUrl("");
          setIsIframeLoaded(false);
          setErrorMessage("");
        }}
        onCancel={() => {
          setOpenForm(!openForm);
          setCompanyDocumentUrl("");
          setIsIframeLoaded(false);
          setErrorMessage("");
        }}
        width={1000}
        zIndex={1100}
        title="Documents"
        footer={
          acceptedForm ? (
            <div className="row">
              <div className="col-md-12">
                <button className="btn btn-primary" onClick={handlePrint}>
                  Print
                </button>
              </div>
            </div>
          ) : (
            <div className="row">
              {isFilledStatus && isIframeLoaded && (
                <div className="col-md-12">
                  {companyDocumentUrl !== null &&
                    companyDocumentUrl !== undefined &&
                    companyDocumentUrl !== "" && (
                      <button
                        disabled={loading}
                        className={`btn ${loading ? "btn-secondary" : "btn-primary"
                          }`}
                        onClick={(e) => acceptFormHandler(e)}
                      >
                        Accept
                      </button>
                    )}
                  &nbsp; &nbsp;
                  {rejectDisable && (
                    <button
                      disabled={loading}
                      className={`btn ${loading ? "btn-secondary" : "btn-danger"
                        }`}
                      onClick={(e) => setOpenReason(true)}
                    >
                      Reject
                    </button>
                  )}
                </div>
              )}
            </div>
          )
        }
      >
        <LoadingArea isLoading={loading}>
          {companyDocumentType ? (
            <>
              <div>
                {errorMessage && (
                  <p
                    style={{ fontSize: "14px", fontWeight: "bold" }}
                    className="text-red-500 text-center w-full"
                  >
                    {errorMessage}
                  </p>
                )}
                <iframe
                  style={{ width: "100%" }}
                  title="iframe"
                  className="iframe"
                  width="100%"
                  height="600"
                  allow="fullscreen; autoplay; clipboard-read; clipboard-write"
                  onLoad={() => setIsIframeLoaded(true)}
                  src={companyDocumentUrl}
                >
                  <p>iframes are not supported by your browser.</p>
                </iframe>
              </div>
            </>
          ) : (
            <>
              <div className="media__print" id="preview"></div>
            </>
          )}
        </LoadingArea>
      </Modal>

      <Modal
        centered
        open={openReason}
        onOk={(e) => setOpenReason(!openReason)}
        onCancel={(e) => setOpenReason(!openReason)}
        width={500}
        zIndex={1200}
        title="Reason"
        footer={
          <div className="row">
            <div className="col-md-12">
              <button
                className={`btn ${rejectReason.trim() !== "" ? "btn-primary" : "btn-secondary"
                  }`}
                disabled={rejectReason.trim() !== "" ? false : true}
                onClick={onRejectHandler}
              >
                Submit
              </button>
            </div>
          </div>
        }
      >
        <div>
          <div className="form-group col-md-12 form-builder-element">
            <label htmlFor="">Type your reason</label>
            <textarea
              placeholder="Enter Your Reason"
              className="border form-control"
              onChange={(e) => setRejectReason(e.target.value)}
              value={rejectReason}
            ></textarea>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        open={documentModal}
        onCancel={() => setDocumentModal(!documentModal)}
        width={500}
        title="Reason"
        footer={
          <div className="row">
            <div className="col-md-12">
              <button
                className={`btn ${pdfRejectData.rejectContent.trim() !== ""
                  ? "btn-primary"
                  : "btn-secondary"
                  }`}
                disabled={
                  pdfRejectData.rejectContent.trim() !== "" ? false : true
                }
                onClick={handleReject}
              >
                Submit
              </button>
            </div>
          </div>
        }
      >
        <div>
          <div className="form-group col-md-12 form-builder-element">
            <label htmlFor="">Type your reason</label>
            <textarea
              className="form-control form-view"
              onChange={(e) =>
                setPdfRejectData({
                  ...pdfRejectData,
                  rejectContent: e.target.value,
                })
              }
              value={pdfRejectData?.rejectContent || ""}
            ></textarea>
          </div>
        </div>
      </Modal>

      {/* Full Document Reject Model */}

      <RejectModal
        open={docRejectModal}
        closeHandler={setDocRejectModal}
        value={docRejectReason}
        setValue={setDocRejectReason}
        onSubmit={() => onRejectHandlerDoc()}
      />

      <Modal
        centered
        open={consentFormModal}
        onOk={(e) => setConsentFormModal(!consentFormModal)}
        onCancel={(e) => setConsentFormModal(!consentFormModal)}
        width={1000}
        zIndex={1100}
        footer={<></>}
        title="Consent Form"
      >
        <div>
          <iframe
            style={{ width: "100%" }}
            title="iframe"
            className="iframe"
            width="100%"
            height="600"
            allow="fullscreen; autoplay; clipboard-read; clipboard-write"
            src={concentUrl}
          >
            <p>iframes are not supported by your browser.</p>
          </iframe>
        </div>
      </Modal>
    </Dashboard>
  );
};

export default DocsVerify;
